import {
    get,
    put,
    post,
    postXtoken,
    putXtoken,
    getMp,
    getMp2,
    postMp,
    getBanner,
    postYUN,
    getYUN,
    delToken,
    putYUNById,
    get2Mp,
    getyunManage,
    get2ById,
    postById,
    delById
  } from "./base_myInfo";

export function putNewMyInfo (data) {
    return putYUNById('/user/mini/app/updPersonalData', data)
}
export function getPersonalData () {
    return get2Mp('/user/mini/app/getPersonalData')
}
// 获取医院列表
export function getHospital(data) {
    return getyunManage("/v3/hospitals", data);
  }
  export function  getLoginDepartment(){
    return getyunManage('/v3/offices',{'pageNum':1,'pageSize':'9999'})
  }
  export function  getJobTitle(identify){
    return getyunManage('/v3/jobtitles',{identify,"pageNum":1,"pageSize":999})
  } 
//获取学校信息
export function getSchool(data){
    return getyunManage('/v3/schools',data)
  }
  export function getPersonTags(){
    return get2ById('/user/mini/app/getPersonTags')
  }
  export function getSysTags(){
    return get2ById('/user/mini/app/getSysTags')
  }
  export function addPersonTag(tag){
    return postById('/user/mini/app/addPersonTag?tag=' + tag)
  }
  export function delPersonTag(data) {
    return delById("/user/mini/app/delPersonTag",data);
  }
// 注销
export function cancelChannel(cancel_channel) {
    return delToken("/user/mina/member?cancel_channel="+cancel_channel);
  }
// 上传证件照  https://application.yunicu.com/user/mini/app/submitAuthentication
export function postAuthentication(data){
  return postById('/user/mini/app/submitAuthentication',data)
}
// 查审核状态  
export function getAppAuthentication(){
  return get2ById('/user/mini/app/getAppAuthentication')
}
// 获取三个月来浏览最多的点播数据
export function getVodMostBrowse(size) {
  return get2ById(`/user/vodMostBrowse/${size}`);
}
// /user/vodMostBrowse/{size}